// サイドバーの通知バッジ（勤怠マイページ・仕様 docs/mypage/通知バッジ仕様_2026-07.md）。
// 件数はすべてサーバが決める。ここには「何を数えるか」「いつ消えるか」のロジックを持たない。
//
// バッジには消える条件が正反対な2種類があり、どちらもサーバ側で処理済み:
//   - 状態由来 (home/attendance/todo): DBの現在の状態そのもの。開いても消えず、
//     承認・振り分け・TODOを対応中にすると減る。
//   - お知らせ由来 (apply/payslip): 最終閲覧時刻より後に起きた件数。該当メニューの
//     既存GET（申請ハブ・給与明細）を叩いた副作用でサーバが既読にするため、
//     フロントから既読を通知する必要はない。
//
// 返るキーはロールごとに異なる（経営者=home/attendance/todo、社員=home/todo/apply/payslip）。
// フロントはロール分岐せず、返ってきたキーをそのまま描画する。

const API_URL = process.env.REACT_APP_API_URL || "";

// 直近の件数をモジュールに保持。画面遷移のたびに MypageLayout が再マウントされるため、
// 初回以外は即座にここから復元してバッジのちらつきを防ぐ（me のキャッシュと同じ方式）。
let cachedCounts = {};

export function getCachedCounts() {
  return cachedCounts;
}

// バッジ件数を取得。失敗時は直近値を返す（バッジのために画面を壊さない）。
export async function fetchBadgeCounts() {
  try {
    const res = await fetch(`${API_URL}/api/employee/notifications/`, { credentials: "include" });
    if (!res.ok) return cachedCounts;
    const data = await res.json();
    cachedCounts = data;
    return data;
  } catch (e) {
    return cachedCounts;
  }
}

// サイドバー(MypageLayout)が件数の変化を受け取るための購読。
const listeners = new Set();

export function onBadgeCounts(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

// 状態由来のバッジを減らす操作（承認/却下・候補の振り分け・TODOの状態変更）の直後に呼ぶ。
// 常時ポーリングはしない（仕様 §8）。自分の操作の結果だけ即座に反映させる＝
// 承認したのにサイドバーが古い件数のまま、を防ぐ。
export async function refreshBadgeCounts() {
  const counts = await fetchBadgeCounts();
  listeners.forEach((fn) => fn(counts));
  return counts;
}

// 社員名の横に出す総数。現在地は除外しない（状態由来の数字は「残っている仕事の量」で、
// どの画面にいるかで変わるのは不自然。お知らせ由来は開けば既読になり自然に0になる）。
export function totalCount(counts) {
  return Object.values(counts || {}).reduce((sum, n) => sum + n, 0);
}
